import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/image/logo.png'


const _hoisted_1 = { class: "nav-horizontal-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "nav-horizontal-main" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "logOut" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "space" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.showLogo)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "icon-content",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickLogo && _ctx.clickLogo(...args)))
        }, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("section", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", {
          class: "logout",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
        }, _toDisplayString(_ctx.$wordList.ProperAllTextLogOut), 1)
      ])
    ])
  ]))
}